import {isCategoryColor, isCategoryIcon} from 'common/categoryAppearance';
import * as React from 'react';
import {
  automaticCategoryColor,
  categoryIconComponents,
  categoryTintClasses,
} from 'src/categoryAppearance';
import {cn} from 'src/lib/utils';

type CategoryLike = {
  name: string;
  icon?: string | null;
  color?: string | null;
};

type Props = {
  category: CategoryLike;
  className?: string;
};

/**
 * Circular category avatar: explicit icon/color when the category has
 * them, otherwise a color hashed from the name with the initial letter.
 * Unknown stored names (e.g. an icon later removed from the list) fall
 * back to automatic rather than rendering broken.
 */
export const CategoryAvatar = (props: Props) => {
  const {category, className} = props;

  const color =
    category.color != null && isCategoryColor(category.color)
      ? category.color
      : automaticCategoryColor(category.name);
  const Icon =
    category.icon != null && isCategoryIcon(category.icon)
      ? categoryIconComponents[category.icon]
      : null;

  return (
    <div
      className={cn(
        'flex size-9 max-md:size-8 shrink-0 items-center justify-center rounded-full',
        categoryTintClasses[color],
        className,
      )}
    >
      {Icon ? (
        <Icon className="size-4" />
      ) : (
        <span className="text-sm font-semibold">
          {category.name.charAt(0).toUpperCase()}
        </span>
      )}
    </div>
  );
};
